<template>
  <footer class="app-footer">
    <p class="mb-0">&copy; 2024 My App. All rights reserved.</p>
  </footer>
</template>

<script>
export default {
  name: "AppFooter",
};
</script>

<style scoped>
/* フッターのスタイル */
.app-footer {
  position: fixed;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 50px;
  z-index: 1000;
  background-color: #f8f8f8;
  padding: 10px 0;
  text-align: center;
}
</style>
